import { useQuery } from '@tanstack/react-query';
import { useAppSelector } from '@store/store';
import {
  selectCurrentDomain,
  selectSiteSettings,
} from '@store/slices/settingsSlice';
import { getSupport } from '../api/assistant';

export const useAssistantSupport = (enabled: boolean) => {
  const site = useAppSelector(selectSiteSettings);
  const currentDomain = useAppSelector(selectCurrentDomain);
  const siteScope = site?.site_code || currentDomain || window.location.host;
  return useQuery({
    queryKey: ['assistant', 'support', siteScope],
    queryFn: getSupport,
    enabled,
    staleTime: 0,
    placeholderData: undefined,
    retry: false,
  });
};
